/* Dani Prueba · Código de descuento real en carrito lateral.
   Usa el endpoint oficial de Shopify /cart/update.js con {discount}.
   Después refresca el panel, sin perder la navegación. */
(() => {
  if(document.documentElement.dataset.arDaniDrawerDiscountBound==='yes')return;
  document.documentElement.dataset.arDaniDrawerDiscountBound='yes';
  let applying=false;
  document.addEventListener('submit', async event => {
    const form=event.target.closest?.('cart-drawer [data-ar-dani-discount-form]');
    if(!form)return;
    event.preventDefault();
    if(applying)return;
    const input=form.querySelector('input[name="discount"]');
    const feedback=form.closest('details')?.querySelector('[data-ar-dani-discount-feedback]');
    const btn=form.querySelector('button[type="submit"]');
    const code=(input?.value||'').trim();
    if(!code){if(feedback){feedback.hidden=false;feedback.textContent='Introduce un código de descuento.';}return;}
    applying=true;
    if(btn){btn.disabled=true;btn.textContent='APLICANDO…';}
    if(feedback){feedback.hidden=true;feedback.textContent='';}
    try{
      const base=window.Shopify?.routes?.root||'/';
      const response=await fetch(base+'cart/update.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({discount:code})
      });
      let result;
      try{result=await response.json();}catch(_){result=null;}
      if(!response.ok||!result||result.status||result.errors){
        throw new Error(result?.description||result?.message||'No se pudo aplicar el código.');
      }
      // Shopify entrega los importes finales desde el propio carrito.
      const refreshUrl=new URL(window.location.href);
      refreshUrl.hash='';
      refreshUrl.searchParams.set('section_id','cart-drawer');
      const updated=await fetch(refreshUrl.toString(),{
        credentials:'same-origin',cache:'no-store'
      });
      if(!updated.ok)throw new Error('El código se envió, pero no se pudo actualizar el carrito.');
      const html=await updated.text();
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const replacement=parsed.querySelector('#CartDrawer .drawer__inner');
      const existing=document.querySelector('cart-drawer #CartDrawer .drawer__inner');
      if(!replacement||!existing)throw new Error('Actualiza el carrito para comprobar tu descuento.');
      existing.replaceWith(replacement);
      const drawer=document.querySelector('cart-drawer');
      if(drawer){
        drawer.classList.remove('is-empty');
        if(result.item_count===0)drawer.classList.add('is-empty');
      }
      const details=document.querySelector('cart-drawer [data-ar-dani-cart-discount]');
      if(details){
        details.open=true;
        const status=details.querySelector('[data-ar-dani-discount-feedback]');
        if(status){
          status.hidden=false;
          status.textContent='Código enviado. Comprueba el descuento en el total o al finalizar la compra.';
        }
        details.querySelector('summary')?.focus({preventScroll:true});
      }
      document.dispatchEvent(new CustomEvent('arome:cart-state',{detail:{cart:result,threshold: 0}}));
    }catch(error){
      const alive=document.querySelector('cart-drawer [data-ar-dani-cart-discount] [data-ar-dani-discount-feedback]');
      if(alive){alive.hidden=false;alive.textContent=error?.message||'No se pudo procesar el código.';}
    }finally{
      applying=false;
      const active=document.querySelector('cart-drawer [data-ar-dani-discount-form] button[type="submit"]');
      if(active){active.disabled=false;active.textContent='APLICAR';}
    }
  });
})();